import React from "react";
import { handleReportError } from "../helpers";
import { ErrorCardProps } from "../ErrorCard";
import { Button } from "@/components/atoms/Button/Button";
import {
  Bug01Icon,
  DiscordIcon,
  Refresh01Icon,
} from "@hugeicons/core-free-icons";
import { Icon } from "@/components/atoms/Icon/Icon";

interface ActionButtonsProps {
  onRetry?: () => void;
  responseError?: ErrorCardProps["responseError"];
  httpError?: ErrorCardProps["httpError"];
  context: string;
  textSize?: "body" | "body-md";
}

export function ActionButtons({
  onRetry,
  responseError,
  httpError,
  context,
  textSize = "body",
}: ActionButtonsProps) {
  return (
    <div
      data-slot="error-card-actions"
      className="flex flex-col flex-wrap gap-3 pt-2 sm:flex-row"
    data-sentry-component="ActionButtons" data-sentry-source-file="ActionButtons.tsx">
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="outline"
          size="small"
          textSize={textSize}
          data-slot="error-card-retry"
        >
          <Icon
            data-slot="error-card-retry-icon"
            icon={Refresh01Icon}
            size={16}
          />
          Try Again
        </Button>
      )}

      <Button
        onClick={() => handleReportError(responseError, httpError, context)}
        variant="ghost"
        size="small"
        textSize={textSize}
        data-slot="error-card-report"
      data-sentry-element="Button" data-sentry-source-file="ActionButtons.tsx">
        <Icon data-slot="error-card-report-icon" icon={Bug01Icon} size={16} data-sentry-element="Icon" data-sentry-source-file="ActionButtons.tsx" />
        Report Error
      </Button>

      <Button
        as="NextLink"
        variant="ghost"
        size="small"
        textSize={textSize}
        href="https://discord.gg/autogpt"
        target="_blank"
        rel="noopener noreferrer"
        data-slot="error-card-help"
      data-sentry-element="Button" data-sentry-source-file="ActionButtons.tsx">
        <Icon data-slot="error-card-help-icon" icon={DiscordIcon} size={16} data-sentry-element="Icon" data-sentry-source-file="ActionButtons.tsx" />
        Get Help
      </Button>
    </div>
  );
}
